import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { MotivoPerdaVendaPLM } from '../motivo-perda-venda-plm';

@Component({
    selector: 'sgt-motivo-perda-venda-plm-form',
    templateUrl: './motivo-perda-venda-plm-form.component.html',
    styleUrls: ['./motivo-perda-venda-plm-form.component.less']
})
export class MotivoPerdaVendaPLMFormComponent {
    @Input() entity: MotivoPerdaVendaPLM;
    @ViewChild('form') form: NgForm;

    constructor(private messageService: MessageService) { }

    /** Verifica se o form do ciclo de vida do produto está válido */
    isValid() {
        if (this.form.invalid) {
            this.messageService.warning('Selecione corretamente todas as opções do ciclo de vida do produto deste motivo', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
